export class LostCredentials {
    userId: string;
    password: string;
    confirmPassword: string;
}


// WEBPACK FOOTER //
// ./src/app/models/lostCredentials.ts